module.exports = __webpack_public_path__ + "static/media/debug.5c02e1a7.log";